import { wrapFontFamily } from 'common/components/entities/Text/utils'
import { usePage } from 'publisher/store'
import pageSelectors from 'publisher/store/page/pageSelectors'
import React, { ReactNode } from 'react'
import Meta from '../components/core/Meta'
import { OnExitPopup } from './components/on-exit-popup'
import { OnloadPopups } from './components/onload-popups'
import { TriggeredPopup } from './components/triggered-popup'
import PageUi from './ui/PageUi'

export interface CommonPageProps {
  children: ReactNode
  noIndex: boolean
}

export const CommonPage = ({ children, noIndex }: CommonPageProps) => {
  const globalTextFontProperties = usePage(
    pageSelectors.getGlobalFontProperties,
  )

  return (
    <PageUi
      $textFontFamily={wrapFontFamily(globalTextFontProperties.fontFamily)}
      $textFontWeight={globalTextFontProperties.fontWeight}
      $textFontStyle={globalTextFontProperties.fontStyle}
    >
      <Meta noIndex={noIndex} />
      {children}
      <TriggeredPopup />
      <OnExitPopup />
      <OnloadPopups />
    </PageUi>
  )
}
